import React, { useState, useEffect } from 'react';
import Imagez from '../../../../../lib/reusable/Imagez';
import { COLORS } from '../../../../../utils/colors';


const TreeServiceElement = (props) => {
  const { service } = props;
  const [errorImage, setErrorImage] = useState(false);

  const handleNoImage = () => {
    setErrorImage(true);
  };

  useEffect(() => {
    setErrorImage(false);
  }, [service])

  const hasImage = (service.has_image || service.randomImageFromProducts) && !errorImage;

  const square = '40px';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        opacity: service.active ? 1 : 0.3,
        marginLeft: '-4px',
        borderLeft: `2px solid ${COLORS.INFO}`,
        padding: '8px',
        backgroundColor: `${COLORS.INFO}05`,
        boxShadow: '0px 6px 8px -3px #00000040',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
        <div
          style={{
            fontWeight: 'bold',
            letterSpacing: '-0.024em',
            marginRight: '10px',
            fontSize: '0.64rem',
            minWidth: '16px',
          }}
        >
          {Math.abs(service.position)}
        </div>
        {hasImage ? (
          <div style={{ width: square, borderRadius: '4px' }}>
            <Imagez
              br="4px"
              image={service.has_image ? service.image : service.randomImageFromProducts}
              height={square}
              handleNoImage={handleNoImage}
              style={{ opacity: service.active ? 1 : 0.3 }}
              loaderWidth={30}
            />
          </div>
        ) : (
          <div style={{ width: square, height: square, background: '#ccc', borderRadius: '4px' }} />
        )}
        <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
          {service.name}
        </div>
      </div>
    </div>
  );
};

export default TreeServiceElement;
